import styled from "styled-components";

export const StyledUserContainer = styled.div<{ onClick?: () => void }>`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: ${(props) => (props.onClick ? "pointer" : "unset")};
`;
